import AvatarBuilderSection from "@/components/home/AvatarBuilderSection";
import SectionTitle from "@/components/ui/section-title";
import { Loader as LoaderIcon } from 'lucide-react';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL

export default function Promo({user, userCredits, isLoadingAuth}) {

  if (isLoadingAuth) {
    return (
        <section className="py-24 bg-gradient-to-br from-white to-purple-50">
          <div className="container mx-auto px-4">
            <SectionTitle 
              title="AI Avatar Builder" 
              subtitle="Create a funny video in just 30 seconds."
            />

            <div className="text-center mb-8">
              <LoaderIcon size={36} className="text-purple-600 animate-spin mb-4" />
            </div>
          </div>
        </section>
    )
  }

  if (user && userCredits < 1) {
    return (
        <section className="py-24 bg-gradient-to-br from-white to-purple-50">
          <div className="container mx-auto px-4">
            <SectionTitle 
              title="AI Avatar Builder" 
              subtitle="Create a funny video in just 30 seconds."
            />

            <div className="text-center mb-8">
              <p className="text-lg text-gray-600">You need at least 1 credit to create an avatar.</p>
            </div>

            <div className="flex justify-center">
              <a
                href={`${API_BASE_URL}/credits`}
                className="rounded-md bg-purple-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-purple-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Get Credits
              </a>
            </div>
            
          </div>
        </section>
    )
  }

  return (
    <>
      <AvatarBuilderSection 
        promo={true} 
        user={user} 
        userCredits={userCredits} 
      />
    </>
  );
}
